/* ==========================================================================
   AECOOLY — homepage category filter
   --------------------------------------------------------------------------
   Client-side show/hide over already-rendered cards. No navigation, no
   network, no re-render — which is the whole point: the header nav still
   routes to the real collection pages, this is the in-page shortcut.

   Implements the WAI-ARIA tabs pattern: one tab is focusable at a time and
   arrow keys move between them (roving tabindex). Without that, a keyboard
   user has to tab through every filter to reach the grid.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initShop(section) {
    if (section.dataset.aeShopReady === 'true') return;
    section.dataset.aeShopReady = 'true';

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ae-tab]'));
    var grid = section.querySelector('[data-ae-shop-grid]');
    var panel = section.querySelector('[role="tabpanel"]');
    var empty = section.querySelector('[data-ae-shop-empty]');
    var status = section.querySelector('[data-ae-shop-status]');
    if (!tabs.length || !grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-ae-cats]'));

    function apply(key, opts) {
      opts = opts || {};
      var shown = 0;

      items.forEach(function (item) {
        var cats = (item.dataset.aeCats || '').split(/\s+/);
        var match = key === 'all' || cats.indexOf(key) !== -1;

        // `hidden` rather than a class: it keeps the element out of the
        // accessibility tree and out of tab order, not merely invisible.
        if (match) {
          item.hidden = false;
          item.style.setProperty('--ae-item-index', shown);
          shown++;
        } else {
          item.hidden = true;
          item.style.removeProperty('--ae-item-index');
        }
      });

      tabs.forEach(function (tab) {
        var on = tab.dataset.aeTab === key;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        // Roving tabindex: only the selected tab is in the tab order.
        tab.tabIndex = on ? 0 : -1;
        if (on && panel) panel.setAttribute('aria-labelledby', tab.id);
      });

      if (empty) empty.hidden = shown !== 0;

      // Replay the entrance so the new set reads as arriving, not as the
      // page silently rearranging underneath the user.
      if (!reduceMotion.matches && !opts.silent) {
        grid.classList.remove('ae-shop__grid--enter');
        // Force reflow so removing and re-adding the class restarts the
        // animation; without it the browser coalesces both mutations.
        void grid.offsetWidth;
        grid.classList.add('ae-shop__grid--enter');
      }

      if (status && !opts.silent) {
        var label = section.querySelector('[data-ae-tab="' + key + '"] .ae-shop__tab-label');
        status.textContent =
          (label ? label.textContent.trim() + ': ' : '') + shown + ' ürün';
      }

      // Shareable without being a navigation. replaceState keeps the back
      // button meaning "the previous page", not "the previous filter".
      if (!opts.silent && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (key === 'all') url.searchParams.delete('kategori');
        else url.searchParams.set('kategori', key);
        window.history.replaceState({}, '', url);
      }
    }

    function select(tab, focus) {
      apply(tab.dataset.aeTab);
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var i = tabs.indexOf(tab);
        var next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = tabs[(i + 1) % tabs.length];
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = tabs[(i - 1 + tabs.length) % tabs.length];
            break;
          case 'Home':
            next = tabs[0];
            break;
          case 'End':
            next = tabs[tabs.length - 1];
            break;
          default:
            return;
        }

        event.preventDefault();
        select(next, true);
      });
    });

    // Honour a ?kategori= deep link on load, without animating or pushing
    // another history entry.
    var initial = 'all';
    try {
      var param = new URL(window.location.href).searchParams.get('kategori');
      if (param && tabs.some(function (t) { return t.dataset.aeTab === param; })) {
        initial = param;
      }
    } catch (e) {
      /* URL unsupported — fall back to showing everything. */
    }
    apply(initial, { silent: true });
  }

  function init() {
    document.querySelectorAll('[data-ae-shop]').forEach(initShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
